import React, { createContext, useContext, useEffect, useState } from 'react';
export type CookieChoices = {
  analytics: boolean;
  marketing: boolean;
};
type CookieConsentValue = {
  decided: boolean;
  choices: CookieChoices;
  panelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
  save: (choices: CookieChoices) => void;
};
const STORAGE_KEY = 'corventa-cookie-consent';
const CookieConsentContext = createContext<CookieConsentValue | null>(null);
export function CookieConsentProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [decided, setDecided] = useState(true);
  const [choices, setChoices] = useState<CookieChoices>({
    analytics: false,
    marketing: false
  });
  const [panelOpen, setPanelOpen] = useState(false);
  useEffect(() => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) setChoices(JSON.parse(raw) as CookieChoices);else setDecided(false);
    } catch {
      setDecided(false);
    }
  }, []);
  const save = (next: CookieChoices) => {
    setChoices(next);
    setDecided(true);
    setPanelOpen(false);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      /* storage unavailable — choice applies to this session only */
    }
  };
  return <CookieConsentContext.Provider value={{
    decided,
    choices,
    panelOpen,
    openPanel: () => setPanelOpen(true),
    closePanel: () => setPanelOpen(false),
    save
  }} data-id="element-594" data-mp="3leklep7gfc9k">
      {children}
    </CookieConsentContext.Provider>;
}
export function useCookieConsent() {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) throw new Error('useCookieConsent must be used within CookieConsentProvider');
  return ctx;
}